// extracted by mini-css-extract-plugin
export default {"not-found-page":"NotFound_not-found-page__qllxl"};